import { useWaveSurfer } from "@/hooks/music-players/use-wave-surfer";
import styles from "@/components/pages/beats/styles/beat-result.module.scss";
import PlayerButton from "@/components/common/player-button";
import WavePlayerProgress from "@/components/common/music-player/wave-player-progress";
import DownloadButton from "@/components/common/command-buttons/download-button";
import { useEffect, useState } from "react";

type BeatResultProps = {
  resultFile: File;
  downloadFile: () => Promise<void>;
};

const BeatResult = ({ resultFile, downloadFile }: BeatResultProps) => {
  const [fileUrl, setFileUrl] = useState(URL.createObjectURL(resultFile));
  const waveSurfer = useWaveSurfer(fileUrl);

  useEffect(() => {
    const audioUrl = URL.createObjectURL(resultFile);
    setFileUrl(audioUrl);

    return () => {
      URL.revokeObjectURL(audioUrl);
    };
  }, [resultFile]);

  return (
    <div className={styles.player_section_wrapper}>
      <PlayerButton
        handleClick={async () => waveSurfer.togglePlay()}
        isPlaying={waveSurfer.isPlaying}
      />
      <WavePlayerProgress displayTime={false} {...waveSurfer} />
      <div className={styles.button_wrapper}>
        <DownloadButton
          handleClick={downloadFile}
          isEnabled={true}
          hideText={true}
        />
      </div>
    </div>
  );
};

export default BeatResult;
